import { alpha } from '@mui/material'
// ==============================|| OVERRIDES - TOGGLE BUTTON ||============================== //

export default function ToggleButtonGroup(theme) {
  return {
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          padding: 2,
          borderRadius: 4,
          backgroundColor: theme.palette.secondary.lighter,
          border: `1px solid ${theme.palette.secondary.main}`,
          boxShadow: ` 0 4px 4px 0 ${alpha(theme.palette.common.black, 0.25)}`,
          '& .MuiToggleButtonGroup-firstButton': {
            borderRadius: 2,
            marginRight: 12,
            borderWidth: '0.5px',
          },
          '& .MuiToggleButtonGroup-middleButton': {
            borderRadius: 2,
            marginRight: 12,
            borderWidth: '0.5px',
          },
          '& .MuiToggleButtonGroup-lastButton': {
            borderRadius: 2,
            marginRight: 0,
            borderWidth: '0.5px',
          },
        },
      },
    },
  }
}
